"use client";

import { memo } from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import {
  useA2UIComponent,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";
import { resolveEnum, renderChildren } from "./utils";

export const BeeOSList = memo(function BeeOSList({
  node,
  surfaceId,
}: A2UIComponentProps<Types.ListNode>) {
  useA2UIComponent(node, surfaceId);
  const props = node.properties;
  const direction = resolveEnum<"horizontal" | "vertical">(props.direction, "vertical");
  const children = Array.isArray(props.children) ? props.children : [];
  const isHorizontal = direction === "horizontal";

  const hostStyle: React.CSSProperties =
    node.weight !== undefined
      ? ({ "--weight": node.weight } as React.CSSProperties)
      : {};

  return (
    <div
      className="a2ui-list overflow-hidden"
      data-direction={direction}
      style={hostStyle}
    >
      <ScrollAreaPrimitive.Root className="relative overflow-hidden">
        <ScrollAreaPrimitive.Viewport className="h-full w-full max-h-[400px] rounded-[inherit]">
          <div
            className={
              isHorizontal
                ? "flex flex-row gap-2 max-w-full"
                : "grid gap-2"
            }
          >
            {renderChildren(children, surfaceId)}
          </div>
        </ScrollAreaPrimitive.Viewport>
        <ScrollAreaPrimitive.Scrollbar
          orientation={isHorizontal ? "horizontal" : "vertical"}
          className={
            isHorizontal
              ? "flex h-2.5 touch-none select-none border-t border-t-transparent p-px transition-colors"
              : "flex w-2.5 touch-none select-none border-l border-l-transparent p-px transition-colors"
          }
        >
          <ScrollAreaPrimitive.Thumb className="relative flex-1 rounded-full bg-border" />
        </ScrollAreaPrimitive.Scrollbar>
        <ScrollAreaPrimitive.Corner />
      </ScrollAreaPrimitive.Root>
    </div>
  );
});
